// extracted by mini-css-extract-plugin
export default {"courseTeamsTable":"CourseTeams_courseTeamsTable__XNErO","teamMemberBadge":"CourseTeams_teamMemberBadge__KT5fC"};